export default __webpack_public_path__ + "static/media/1.8f1c9331.svg";